import Value from "./Value";
import { ValueType } from "./ValueType";

export default class BooleanValue extends Value {
    /**
     * @param {string} id 
     * @param {boolean} value 
     */
    constructor(id, value) {
        super(id);

        /**
         * @constant
         * @type {boolean}
         */
        this.initialValue = value;
        /**
         * @type {boolean}
         */
        this.value = value;
    }

    /**
     * @returns {boolean}
     */
    isValue() {
        return this.value;
    }

    /**
     * @param {boolean} value 
     */
    setValue(value) {
        this.value = value;
    }

    toggleValue() {
        this.value = !this.value;
    }

    /**
     * @override
     */
    reset() {
        this.value = this.initialValue;
    }

    /**
     * @override
     * @returns {number}
     */
    getValueType() {
        return ValueType.BOOLEAN;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isAtInitialValue() {
        return this.value === this.initialValue;
    }

    /**
     * @override
     * @returns {boolean}
     */
    isValueApplicable() {
        return this.value != this.initialValue;
    }

}